<template>
  <j-select-biz-component :width="1000" v-bind="configs" v-on="$listeners"/>
</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'

  export default {
    name: 'JSelectProductLabel',
    components: { JSelectBizComponent },
    props: ['value'],
    data() {
      return {
        settings: {
          name: '标签',
          displayKey: 'name',
          returnKeys: ['id', 'id'],
          listUrl: '/ProductTypes/productTypes/list',
          queryParamCode: 'name',
          queryParamText: '标签名称',
          columns: [
            { title: '商品类型名称', dataIndex: 'name', align: 'center', width: '80%', widthRight: '70%' },
      /*      { title: '职务编码', dataIndex: 'code', align: 'center', width: '35%' }*/
           /* { title: '职级', dataIndex: 'rank_dictText', align: 'center', width: '25%' }*/
          ]
        }
      }
    },
    computed: {
      configs() {
        console.log(this)
        return Object.assign({ value: this.value }, this.settings, this.$attrs)
      }
    }
  }
</script>

<style lang="less" scoped></style>